import { render } from "./CompareOverviewPrice.vue?vue&type=template&id=176a90ec"
import script from "./CompareOverviewPrice.vue?vue&type=script&lang=js"
export * from "./CompareOverviewPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__